const API_BASE = process.env.REACT_APP_API_URL
  ? (process.env.REACT_APP_API_URL.endsWith('/api')
      ? process.env.REACT_APP_API_URL
      : `${process.env.REACT_APP_API_URL}/api`)
  : 'https://stonari-official-backend.onrender.com/api';

const getAuthHeader = async () => {
  try {
    const { auth } = await import('../config/firebase');
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      return { Authorization: `Bearer ${token}` };
    }
  } catch (e) {
    console.error('Token error:', e);
  }
  return {};
};

const request = async (method, url, body) => {
  const authHeaders = await getAuthHeader();
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders,
    },
  };
  if (body !== undefined) {
    options.body = JSON.stringify(body);
  }

  const res = await fetch(`${API_BASE}${url}`, options);

  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const message = data?.message || `Request failed with status ${res.status}`;
    throw new Error(message);
  }

  return { data };
};

const api = {
  get:    (url)        => request('GET',    url),
  post:   (url, body)  => request('POST',   url, body),
  put:    (url, body)  => request('PUT',    url, body),
  delete: (url)        => request('DELETE', url),
};

export default api;
